// 3rd party
import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import * as _ from 'lodash';
import { Observable } from 'rxjs/Observable';

// App
import { AppConfig } from '../app.config';

@Injectable()
export class AjaxService {
    constructor(private appConfig: AppConfig, private http: Http) {
        this.apiUrl = this.appConfig.getValue('apiUrl');
    }

    // Properties
    apiUrl: string = null;

    //---------------------------------
    // Methods
    //---------------------------------

    get(url) {
        if (url.substring(0, 1) !== '/') {
            url = `/${url}`;
        }

        return this.http
            .get(this.apiUrl + url)
            .map((response: Response) => JSON.parse(_.get(response, '_body')))
            .catch((error: Error) => Observable.throw(error));
    }

    post(url, data) {
        if (url.substring(0, 1) !== '/') {
            url = `/${url}`;
        }

        return this.http
            .post(this.apiUrl + url, data)
            .map((response: Response) => JSON.parse(_.get(response, '_body')))
            .catch((error: Error) => Observable.throw(error));
    }

    getAssetUrl(url){

        if(!url) return null;

        const isUrlAbsolute = (url.indexOf('//') === 0 ? true : url.indexOf('://') === -1 ? false : url.indexOf('.') === -1 ? false : url.indexOf('/') === -1 ? false : url.indexOf(':') > url.indexOf('/') ? false : url.indexOf('://') < url.indexOf('.') ? true : false);
        return (isUrlAbsolute ? url : this.apiUrl + url);
    }
}


// WEBPACK FOOTER //
// ./src/app/services/ajax.service.ts